import { readable } from 'svelte/store';
const urlParams = new URLSearchParams(window.location.search);
const settings = new Map();
for (const [key, value] of urlParams.entries()) {
    settings.set(key, value);
}
const settingsDataStore = readable(settings, set => {
    set(settings);
});
export { settingsDataStore };
